// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import store from './store'
import '@/icons' // icon
import '@/permission' // permission control
import 'normalize.css/normalize.css'// A modern alternative to CSS resets
import './assets/scss/style.scss';
import '@/styles/index.scss'
import commonUtils from "./utils/commonUtils"; // global css
import * as echarts from 'echarts';
import dataV from '@jiaminghi/data-view';
import localStorage from './utils/storage'
import less from 'less'
import pxtorem from './utils/pxtorem'

document.onselectstart = function () { return false; }
Vue.use(ElementUI, { locale })

Vue.use(less)
Vue.use(dataV)
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.prototype.$LocalStorage=localStorage;

Vue.prototype.myLoading = function (title) {
  let text = "正在操作中，请稍后!!!";
  if (!commonUtils.isStringNull(title)) {
    text = title;
  }
  const loading = this.$loading({
    lock: true,
    text: text,
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.1)",
  });
  setTimeout(function () {                // 设定定时器，超时5S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题
    loading.close();
  },3000)
  return loading;

}


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'

})



// WEBPACK FOOTER //
// ./src/main.js